export function getDateRange(fromDate, toDate) {
  const fromDateObj = moment(fromDate);
  const toDateObj = moment(toDate);
  if (fromDateObj > toDateObj) {
    return [];
  }
  const result = [];
  let currentDateObj = fromDateObj;
  while (currentDateObj <= toDateObj) {
    result.push(currentDateObj.format("YYYY-MM-DD"));
    currentDateObj = moment(currentDateObj).add(1, "days");
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/lib/utils/date.js